<template>
  <BookmarkCard :tag-type="tagType" icon-name="user">
    <template #content>
      <div class="EtablissementProjectCard-text name">
        {{ userDemande.prenom }} {{ userDemande.nom }}
      </div>
      <div class="EtablissementProjectCard-text">{{ $t(userDemande.profil) }}</div>
      <div class="EtablissementProjectCard-text">{{ userDemande.courriel }}</div>
    </template>
    <template #footer>
      <div class="buttons EtablissementProjectCard-buttons">
        <b-button
          type="is-danger"
          icon-left="trash-alt"
          rounded
          outlined
          @click="rejectDemande"
        ></b-button>
        <b-button type="is-primary" rounded @click="acceptDemande">{{ $t("accept") }}</b-button>
      </div>
    </template>
  </BookmarkCard>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import BookmarkCard from "../generic_components/BookmarkCard.vue"
import { TAG_TYPES_FOR_BOOKMARK_CARD } from "@/model/bean/EnumHelper"
import { UtilisateurDTO } from "@/model/bean/GeneratedDTOs"
import { BButton } from "buefy"

export default defineComponent({
  name: "GraeMemberDemandeCard",
  components: {
    BookmarkCard,
    BButton,
  },
  props: {
    userDemande: Object as PropType<UtilisateurDTO>,
    accept: Function as PropType<(user: UtilisateurDTO) => void>,
    reject: Function as PropType<(user: UtilisateurDTO) => void>,
  },
  data() {
    return {
      tagType: TAG_TYPES_FOR_BOOKMARK_CARD.VALIDATION,
      projectJoined: false,
    }
  },
  methods: {
    acceptDemande(): void {
      if (this.accept) {
        this.accept(this.userDemande)
      }
    },
    rejectDemande(): void {
      if (this.reject) {
        this.reject(this.userDemande)
      }
    },
  },
})
</script>

<style lang="scss">
@import "@/styles/variables";

.EtablissementProjectCard-buttons {
  width: 100%;
  padding: 0 0.25rem;

  &.buttons {
    justify-content: flex-end;

    .button {
      min-width: 57px;
      text-transform: uppercase;
    }
  }
}

.EtablissementProjectCard-text {
  text-align: center;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;

  &.name {
    font-weight: 700;
  }
}

.EtablissementProjectCard-joined {
  display: flex;
  align-items: center;
  font-style: italic;
  color: $success;
  cursor: pointer;
}
</style>
